/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CourseRequest = {
    agentId: string;
    title: string;
    description: string;
    imageUrl: string;
    language: CourseRequest.language;
};
export namespace CourseRequest {
    export enum language {
        EN = 'EN',
        DE = 'DE',
    }
}

